import React from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import BaseGameTotal from './base-game-total';

class GameTotal extends BaseGameTotal {
    render() {
        const gameTotal = this.getGameTotal();
        return (
            <div className="total-text" style={{...this.getBackgroundColor(gameTotal)}}>
                <span>Total: {NumberHelper.float(gameTotal, 3)}</span>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;
    return {
        sportConfig,
    };
}

const GameTotalComponent = connect(mapStatesToProps)(GameTotal);

export {GameTotalComponent};
